import Typography from '@mui/material/Typography';

export default function NotFound() {
  return (
    <Typography variant="h1" component="div" gutterBottom>
      404, aquí no hay nada
    </Typography>
  );
}